import React from "react";
import {GST_INCLUSIVE} from "../../modules/PriceBlock/GstTypes";

const GstToggle = ({gstType, onChange}) => {
  const isGstInclusive = gstType === GST_INCLUSIVE;

  return (
    <span className="pdp-prices-block__option pdp-prices-block__option--gst">
      <input type="checkbox" name="price-gst-check" id="price-gst-check"
             checked={isGstInclusive} onChange={onChange} />
      <label htmlFor="price-gst-check"
             className="pdp-prices-block__label pdp-prices-block__label--cb js-pdp__gst-check">
          GST
      </label>
    </span>
  )
};

GstToggle.defaultProps = {
  gstType: GST_INCLUSIVE
};

export default GstToggle;